<div *ngIf="data" class="center-child">

    <section>
        <h6>{{ data.title }}</h6>
    
        <mat-progress-bar 
            *ngIf="data?.progressBarOptions" 
            class="mb-24" 
            [mode]="data.progressBarOptions.mode" 
            [color]="data.progressBarOptions.color" 
            [value]="data.progressBarOptions.value || 100" 
        ></mat-progress-bar>
    
        <div class="mat-subtitle-2 form-hint">{{ data.message }}</div>
        
        <div class="status-action">
            <ng-content></ng-content>
        </div>
    </section>
</div>